import injectSheet from 'react-jss'
import Button from './Button'
import styles from './Button.styles'

export default injectSheet(styles)(Button)
